import { render, staticRenderFns } from "./installVideo.vue?vue&type=template&id=5aa4b87c&scoped=true&"
import script from "./installVideo.vue?vue&type=script&lang=js&"
export * from "./installVideo.vue?vue&type=script&lang=js&"
import style0 from "./installVideo.vue?vue&type=style&index=0&id=5aa4b87c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa4b87c",
  null
  
)

export default component.exports